import cn from 'classnames';
import React, {FC} from 'react';

import Button from '../Button';
import {IButton} from '../ButtonTypes';
import styles from './FloatButton.module.scss';

const FloatButton: FC<IButton> = (props) => {
    const {className, ...restProps} = props;
    const buttonClassName = cn(styles.FloatButton, className);

    return <Button {...restProps} className={buttonClassName} />;
};

export default FloatButton;
